import  * as yup from "yup";
export const OrderTreatmentSchema = yup.object({
    order_type: yup
    .string()
    .required(`can't be blank`),
    po_number: yup
    .string(),
});
